import { Component, OnInit } from '@angular/core';
import { FileUploadComponent } from 'src/app/file-upload/file-upload.component';
import { MatDialog } from '@angular/material';
import { AngularFireDatabase } from 'angularfire2/database';
import { ToastrService } from 'ngx-toastr';
import * as firebase from 'firebase';

@Component({
  selector: 'app-ocorrencia',
  templateUrl: './ocorrencia.component.html',
  styleUrls: ['./ocorrencia.component.scss']
})
export class OcorrenciaComponent implements OnInit {

  funcionario: any;
  email: any;
  descricao: any;
  documentos: any;
  funcionarios: any[] = [];
  funcionariosById = {};
  senha: any;
  constructor(public dialog: MatDialog,  private toastr: ToastrService, private db: AngularFireDatabase) {
    db.database.ref('acesso/funcionarios').once('value').then(res => {
      res.forEach(func => {
        const f = func.val();
        f.id = func.key;
        this.funcionarios.push(f);
        this.funcionariosById[f.id] = f;
      });
      // console.log(this.funcionarios);
    });
  }

  ngOnInit() {
  }

  upload() {
    // console.log('aa', x);
    const dialogRef = this.dialog.open(FileUploadComponent, {
      width: '800px',
      // height: '75%',
      maxHeight: '80vh',
      data: {}
    });
    dialogRef.afterClosed().subscribe(res => {
      if (res) {
        this.documentos = res;
        console.log(res);
      }
    });
  }

  isOk(d) {
    if (!d) { return false; }
    const x = d.toString();
    if (!x || x.trim().length === 0 || x.trim() === '') {
      return false;
    }
    return true;
  }

  send() {
    if (!this.isOk(this.descricao)) {
      this.toastr.error('Você deve descrever o motivo da ocorrência');
      return;
    }

    if (!this.isOk(this.funcionario)) {
      this.toastr.error('Você deve selecionar seu nome');
      return;
    }

    if (!this.isOk(this.senha)) {
      this.toastr.error('Você deve informar sua senha');
      return;
    }

    if (!this.isOk(this.email)) {
      this.toastr.error('Você deve informar seu email');
      return;
    }

    if (this.senha.toString() !== this.funcionariosById[this.funcionario].senha.toString()) {
      this.toastr.error('Senha inválida.');
      return;
    }
    
    const json = {
      descricao: this.descricao,
      email: this.email,
      documentos: this.documentos || '',
      nome: this.funcionariosById[this.funcionario].nome,
      created: firebase.database.ServerValue.TIMESTAMP,
    };

    this.db.database.ref(`acesso/ocorrencias/${this.funcionario}`).push(json).then(() => {
      this.toastr.success('Ocorrência cadastrada com sucesso!');
      this.descricao = null;
      this.email = null;
      this.documentos = null;
      this.senha = null;
    });

    console.log(this.funcionario);
  }

  changeFunc(e) {
    // console.log(e);
    this.funcionario = e;
  }

}
